
// /* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  MessageCircle,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
  Youtube
} from 'lucide-react';

const Footer = () => {
  const phoneNumber = '7278000038';

  const handleWhatsAppClick = () => {
    const message = 'Hi! I would like to book a scrap pickup.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <>
      {/* Phone Call Floating Button */}
      <motion.button
        onClick={handleCallClick}
        className="fixed bottom-24 right-6 z-50 w-14 h-14 bg-[#2F6F45] hover:bg-[#70BD7D] text-white rounded-full shadow-large flex items-center justify-center group"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.8, type: "spring", stiffness: 200 }}
      >
        <Phone className="w-7 h-7" />
        <div className="absolute -top-12 right-0 bg-[#102018] text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Call us now
        </div>
      </motion.button>

      {/* WhatsApp Floating Button */}
      <motion.button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#2F6F45] hover:bg-[#70BD7D] text-white rounded-full shadow-large flex items-center justify-center group"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 200 }}
      >
        <MessageCircle className="w-7 h-7" />
        <div className="absolute -top-12 right-0 bg-[#102018] text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
          Chat with us on WhatsApp
        </div>
      </motion.button>

      {/* Footer */}
      <footer className="bg-[#102018] text-white">
        <div className="container-custom">
          <div className="py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Company Info */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="lg:col-span-1"
              >


    <div className="mb-6 flex items-center">


  <span className="ml-1 text-3xl font-heading font-bold text-[#FFFFFF]">
    Scrap<span className="text-[#70BD7D]">Sector</span>
  </span>
</div>



                <p className="text-[#718078] mb-6 leading-relaxed">
                  Your hassle-free door-to-door scrap pickup service in Chandighar ,Punchkula & Mohali. 
                  Book through our website or call us for instant service.
                </p>
                <div className="flex space-x-4">
                  {[
                    { icon: Facebook, href: '#', color: 'hover:text-[#70BD7D]' },
                    { icon: Instagram, href: 'https://www.instagram.com/scrapsector?igsh=MTh3YmFoYzdsOWUwag==', color: 'hover:text-[#70BD7D]' },
                    { icon: Linkedin, href: 'https://www.linkedin.com/company/scrapsector/', color: 'hover:text-[#70BD7D]' },
                    {icon: Youtube, href: 'https://youtube.com/@scrapsectorbusiness?si=KKptBfguTu5bn9j3', color: 'hover:text-[#70BD7D]' }, 
                     
                  ].map((social, index) => ( 
                    <motion.a 
                      key={index} 
                      href={social.href} 
                      className={`w-10 h-10 bg-[#1C3025] rounded-lg flex items-center justify-center text-[#718078] ${social.color} transition-colors duration-200`} 
                      whileHover={{ scale: 1.1 }} 
                      whileTap={{ scale: 0.9 }} 
                    > 
                      <social.icon className="w-5 h-5" /> 
                    </motion.a> 
                  ))} 
                </div> 
              </motion.div> 
 
              {/* Quick Links */} 
              <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.5, delay: 0.1 }} 
                viewport={{ once: true }} 
              > 
                <h4 className="text-lg font-heading font-semibold mb-6">Quick Links</h4> 
                <ul className="space-y-3"> 
                  {[ 
                    { to: '/price-list', label: 'Scrap Rates' }, 
                    { to: '/e-waste-scrap', label: 'E-Waste Scrap' }, 
                    { to: '/services', label: 'Services' }, 
                    { to: '/contact-us', label: 'Contact Us' }, 
                    { to: '/', label: 'Home' } 
                  ].map((link, index) => ( 
                    <li key={index}> 
                      <Link  
                        to={link.to} 
                        className="text-[#718078] hover:text-[#70BD7D] transition-colors duration-200 flex items-center group" 
                      > 
                        <span className="w-1 h-1 bg-[#70BD7D] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span> 
                        {link.label} 
                      </Link> 
                    </li> 
                  ))} 
                </ul> 
              </motion.div> 
 
              {/* Legal */} 
              <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.5, delay: 0.2 }} 
                viewport={{ once: true }} 
              > 
                <h4 className="text-lg font-heading font-semibold mb-6">Legal</h4> 
                <ul className="space-y-3"> 
                  {[ 
                    { to: '/privacy-policy', label: 'Privacy Policy' }, 
                    { to: '/terms-and-conditions', label: 'Terms & Conditions' } 
                  ].map((link, index) => ( 
                    <li key={index}> 
                      <Link  
                        to={link.to} 
                        className="text-[#718078] hover:text-[#70BD7D] transition-colors duration-200 flex items-center group" 
                      > 
                        <span className="w-1 h-1 bg-[#70BD7D] rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span> 
                        {link.label} 
                      </Link> 
                    </li> 
                  ))} 
                </ul> 
              </motion.div> 
 
              {/* Contact Info */} 
              <motion.div 
                initial={{ opacity: 0, y: 20 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.5, delay: 0.3 }} 
                viewport={{ once: true }} 
              > 
                <h4 className="text-lg font-heading font-semibold mb-6">Get in Touch</h4> 
                <div className="space-y-4"> 
                  <div className="flex items-start space-x-3"> 
                    <MapPin className="w-5 h-5 text-[#70BD7D] mt-1 flex-shrink-0" /> 
                    <p className="text-[#718078] text-sm leading-relaxed"> 
                      Manakpur, Thakurdass, Near Railway Crossing (Peer Baba),  
                      Kalka, Pinjore, Panchkula, Haryana, 134102 
                    </p> 
                  </div> 
                  <div className="flex items-center space-x-3"> 
                    <Mail className="w-5 h-5 text-[#70BD7D] flex-shrink-0" /> 
                    <a  
                      href="mailto:scrapsectorbusiness@gmail.com" 
                      className="text-[#718078] hover:text-[#70BD7D] transition-colors duration-200" 
                    > 
                      scrapsectorbusiness@gmail.com 
                    </a> 
                  </div> 
                  <div className="flex items-center space-x-3"> 
                    <Phone className="w-5 h-5 text-[#70BD7D] flex-shrink-0" /> 
                    <a  
                      href="tel:7278000038" 
                      className="text-[#718078] hover:text-[#70BD7D] transition-colors duration-200" 
                    > 
                      7278000038 
                    </a> 
                  </div> 
                </div> 
              </motion.div> 
            </div> 
          </div> 
 
          {/* Bottom Bar */} 
          <motion.div 
            initial={{ opacity: 0 }} 
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }} 
            viewport={{ once: true }} 
            className="border-t border-[#2F6F45] py-6" 
          > 
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"> 
              <p className="text-[#718078] text-sm"> 
                © 2020–2026 ScrapSector Pvt.Ltd. | All Rights Reserved. 
              </p> 
              <div className="flex items-center space-x-6 text-sm text-[#718078]"> 
                <span>Made with in India</span> 
                <span>•</span> 
                <span>Eco-Friendly Recycling</span> 
              </div> 
            </div> 
          </motion.div> 
        </div> 
      </footer> 
    </>
  );
};

export default Footer;